import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import { useOnboardingStatus } from "./useOnboardingStatus";

type UseRequireOnboardingArgs = {
  projectId: number | null | undefined;
  projectReady?: boolean;
  requireAdSettings?: boolean;
  redirectTo?: string;
  warnIfExternalLinkMissing?: boolean;
};

export const useRequireOnboarding = ({
  projectId,
  projectReady = true,
  requireAdSettings = true,
  redirectTo = "/onboarding",
  warnIfExternalLinkMissing = false,
}: UseRequireOnboardingArgs) => {
  const navigate = useNavigate();
  const { status, loading, error, refetch } = useOnboardingStatus(projectId);
  const [showExternalLinkWarning, setShowExternalLinkWarning] = useState(false);

  useEffect(() => {
    if (!projectReady) {
      return;
    }

    if (!projectId) {
      setShowExternalLinkWarning(false);
      navigate(redirectTo);
      return;
    }

    if (!status) {
      setShowExternalLinkWarning(false);
      return;
    }

    if (requireAdSettings && !status.is_ad_settings_done) {
      navigate(redirectTo);
      return;
    }

    setShowExternalLinkWarning(
      Boolean(warnIfExternalLinkMissing && !status.is_ad_account_linked)
    );
  }, [navigate, projectId, projectReady, redirectTo, requireAdSettings, status, warnIfExternalLinkMissing]);

  return {
    onboardingStatus: status,
    onboardingLoading: loading,
    onboardingError: error,
    showExternalLinkWarning,
    refetchOnboardingStatus: refetch,
  };
};
